export const formatAjd = (ajd) => {
  const attributes = {};
  const relationships = {};
  const id = ajd.id && ajd.id !== 'dummy' ? ajd.id : undefined;

  if (ajd.comunidad && ajd.valor) {
    attributes.title = `${ajd.comunidad}-${ajd.valor}`;
  }
  if (ajd.comunidad) {
    attributes.ajd_comunidad = ajd.comunidad;
  }
  if (ajd.valor) {
    attributes.ajd_valor = ajd.valor;
  }
  return {
    data: {
      id,
      type: 'node--ajd',
      attributes,
      relationships,
    },
  };
};

export const processAjd = (ajd) => {
  const { attributes, id, type } = ajd;
  const ajdModel = { id, type };
  if ('title' in attributes) {
    ajdModel.title = attributes.title;
  }
  if ('ajd_comunidad' in attributes) {
    ajdModel.comunidad = attributes.ajd_comunidad;
  }
  if ('ajd_valor' in attributes) {
    ajdModel.valor = attributes.ajd_valor;
  }
  return ajdModel;
};

export const processAjdResponse = (res) => {
  if (res.data.meta) {
    return res.data.data.map(ajd =>
      processAjd(ajd));
  }
  return processAjd(res.data.data);
};



// WEBPACK FOOTER //
// ./src/features/ajd/utils.js